"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOneWayFlightMinPrice = void 0;
const getOneWayFlightMinPrice = (flight) => {
    const getPrice = ({ priceStandard, fuelFee, airportFee }) => (priceStandard + fuelFee + airportFee);
    const { priceList = [] } = flight.rate;
    const sortedByPrice = [...priceList].sort((a, b) => getPrice(a) - getPrice(b));
    const min = sortedByPrice === null || sortedByPrice === void 0 ? void 0 : sortedByPrice[0];
    return min ? getPrice(min) : 0;
};
exports.getOneWayFlightMinPrice = getOneWayFlightMinPrice;
//# sourceMappingURL=utils.js.map